export default __webpack_public_path__ + "static/media/hht1_storybook_16.fe3116bd.png";